import React from "react";
import DataField from "../../utils/DataField"
import {titleCase, formatAsMoney, getProperMetadata, clientAge, formatListOfObjects, formatAddress} from "../../utils/utils"
import { useTranslation } from "react-i18next";
import MapIcon from "@material-ui/icons/Map";

function CreditAnalysisClientProfile(props) {
    const { t } = useTranslation();
    let {credit_analysis} = props

    let decision_metadata = credit_analysis.credit_proposal_legal_person_analysis_events ? getProperMetadata(credit_analysis.credit_proposal_legal_person_analysis_events) : ""
    let basic_data = decision_metadata ? (decision_metadata || {}).basic_data : ""
    let registration_data = (decision_metadata || {}).registration_data || {}

    const getRegistrationDataTooltip = (flag) => {
        if (flag === "positive") {
            return t("Dado validado em fontes externas")
        }
        if (flag === "negative") {
            return t("Dado divergente de fontes externas")
        }
        return t("Dado ausente em fontes externas")
    }

    return (
        <div className="analysisCard">
            <div className={["blueText", "subtitleSize"].join(" ")} style={{marginBottom:"10px"}}>{t("Dados Básicos")}</div>
                <div style={{display: "flex", flexDirection:"column"}}>
                    <div style={{display: "flex", flexDirection: "column"}}>
                        {credit_analysis.legal_name ||  (basic_data || {}).legal_name ?
                        <DataField
                            title={"Razão Social"}
                            label={credit_analysis.legal_name
                                ? titleCase(credit_analysis.legal_name, t("Não disponível"))
                                : titleCase(basic_data.legal_name, t("Não disponível"))}
                            size={"normalMediumSize"}
                            titleNoWrap={false}
                        />: null}
                        {credit_analysis.email ?
                            <DataField
                            title={"Email"}
                            label={credit_analysis.email ? credit_analysis.email : t("Não disponível")}
                            size={"normalMediumSize"}
                            titleNoWrap={false}
                        >
                        </DataField>: null}
                        <DataField
                            title={"CNPJ"}
                            label={credit_analysis.document_number || t("Não disponível")}
                            size={"normalMediumSize"}
                            titleNoWrap={false}
                        />
                        {credit_analysis.monthly_revenue ?
                            <DataField
                            title={"Faturamento mensal"}
                            label={formatAsMoney("BRL",credit_analysis.monthly_revenue) || t("Não disponível")}
                            size={"normalMediumSize"}
                            titleNoWrap={false}
                        />:null}
                        {registration_data.legal_name?.description &&
                            <DataField
                                title={t("legal_name")}
                                label={titleCase(registration_data.legal_name.description, "-")}
                                size={"normalMediumSize"}
                                titleNoWrap={false}
                                check={registration_data.legal_name.flag}
                                tooltipText={getRegistrationDataTooltip(registration_data.legal_name.flag)}
                            />}
                        {registration_data.trading_name?.description &&
                            <DataField
                                title={t("trading_name")}
                                label={titleCase(registration_data.trading_name.description, "-")}
                                size={"normalMediumSize"}
                                titleNoWrap={false}
                                check={registration_data.trading_name.flag}
                                tooltipText={getRegistrationDataTooltip(registration_data.trading_name.flag)}
                            />}
                        {registration_data.foundation_date?.description &&
                            <DataField
                                title={t("foundation_date")}
                                label={clientAge(registration_data.foundation_date.description) || "-"}
                                size={"normalMediumSize"}
                                titleNoWrap={false}
                                check={registration_data.foundation_date.flag}
                                tooltipText={getRegistrationDataTooltip(registration_data.foundation_date.flag)}
                            />}
                        {(registration_data.phone_number || []).length > 0 &&
                            <DataField
                                title={t("phones")}
                                label={formatListOfObjects(registration_data.phone_number, "phones", t)}
                                size={"normalMediumSize"}
                                titleNoWrap={false}
                            />}
                        {(registration_data["e-mail"] || []).length > 0 &&
                            <DataField
                                title={t("emails")}
                                label={formatListOfObjects(registration_data["e-mail"], "emails", t)}
                                size={"normalMediumSize"}
                                titleNoWrap={false}
                            />}
                        {(registration_data.address || []).length > 0 &&
                            <DataField
                                title={t("addresses")}
                                label={formatListOfObjects(registration_data.address, "addresses", t)}
                                size={"normalMediumSize"}
                                titleNoWrap={false}
                            >
                                {registration_data.address.map((address) => (
                                    <a
                                        href={"https://www.google.com/maps/search/?api=1&query=" +
                                            formatAddress(address, t("-")).replace(/ /g, "%20").replace(/,/, '%2C')}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <MapIcon style={{verticalAlign: "middle", width: "20px", height:"20px", cursor:"pointer", color:"#777", margin: "auto 5px"}} />
                                    </a>
                                ))}
                            </DataField>}
                    </div>
                </div>
        </div>
    );
}

export default CreditAnalysisClientProfile;
